/* Similar shirts when the selected color is missing a size.
   Reads VariantInventoryJson for this product and EzinkSimilar for others. */
(function (root, factory) {
  var api = factory();
  if (typeof module !== "undefined" && module.exports) module.exports = api;
  if (root) root.EZINKSimilar = api;
  if (typeof document !== "undefined") {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () { boot(api); });
    } else {
      boot(api);
    }
  }

  function boot(api) {
    var box = document.querySelector("[data-ezink-similar]");
    if (!box) return;
    var section = box.closest("[data-section-id]") || document;
    var sectionId = section.getAttribute("data-section-id") || "";

    function paint() {
      var color = api.selectedColor(section);
      var own = api.readJson("VariantInventoryJson-" + sectionId) || api.readJsonPrefix("VariantInventoryJson-");
      var similarDoc = api.readJson("EzinkSimilar") || { similar: [] };
      var view = api.offersFor(own || {}, similarDoc.similar || [], color);
      var economy = api.economyFor(similarDoc.similar || [], color, box.getAttribute("data-product-price"));
      api.render(box, section, view, economy, (similarDoc.similar || []).length);
    }

    document.addEventListener("ezink-size-qty-rebuilt", function () {
      setTimeout(paint, 0);
    });
    document.addEventListener("click", function (event) {
      var hit = event.target && event.target.closest && event.target.closest("[data-ezink-open-soldout]");
      if (!hit) return;
      event.preventDefault();
      event.stopPropagation();
      var tab = box.querySelector('[data-ezink-tab="soldout"]');
      if (!tab || tab.hidden || box.hidden) return;
      tab.click();
      if (box.scrollIntoView) box.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }, true);
    paint();
  }
})(typeof window !== "undefined" ? window : this, function () {
  var SIZE_RE = /^(xxs|xs|s|m|l|xl|2xl|3xl|4xl|5xl|6xl|osfa|os|one size|ysm|ys|ym|yl|yxl|s\/m|m\/l|l\/xl|nb|6m|12m|18m|24m|2t|3t|4t|5t|6t)$/i;
  var FAMILIES = {
    burgundy: ["burgundy", "maroon", "cardinal", "wine", "cranberry"],
    maroon: ["maroon", "burgundy", "cardinal", "wine"],
    cardinal: ["cardinal", "burgundy", "maroon"],
    red: ["red", "true red", "cardinal"],
    navy: ["navy", "navy blue", "deep navy"],
    black: ["black", "jet black"],
    white: ["white"],
    gray: ["gray", "grey", "sport grey", "ash", "ash grey"],
    grey: ["grey", "gray", "sport grey", "ash", "ash grey"]
  };

  function norm(value) {
    return String(value || "").trim().toLowerCase();
  }

  var SIZE_WORDS = {
    xxs: "Extra extra small",
    xs: "Extra small",
    s: "Small",
    m: "Medium",
    l: "Large",
    xl: "Extra large",
    "2xl": "2X-large",
    "3xl": "3X-large",
    "4xl": "4X-large",
    "5xl": "5X-large",
    "6xl": "6X-large",
    osfa: "One size",
    os: "One size",
    "one size": "One size",
    onesize: "One size",
    ysm: "Youth small/medium",
    ys: "Youth small",
    ym: "Youth medium",
    yl: "Youth large",
    yxl: "Youth extra large",
    "s/m": "Small/medium",
    "m/l": "Medium/large",
    "l/xl": "Large/extra large",
    nb: "Newborn",
    "6m": "6 months",
    "12m": "12 months",
    "18m": "18 months",
    "24m": "24 months"
  };

  function sizeWords(size) {
    var key = norm(size).replace(/\s+/g, "");
    return SIZE_WORDS[key] || size || "";
  }

  function splitKey(key) {
    var parts = String(key || "").split("|").map(function (part) {
      return part.trim();
    }).filter(Boolean);
    if (parts.length !== 2) return null;
    if (SIZE_RE.test(parts[1])) return { color: parts[0], size: parts[1] };
    if (SIZE_RE.test(parts[0])) return { color: parts[1], size: parts[0] };
    return { color: parts[0], size: parts[1] };
  }

  function stockFromInventory(inv) {
    var stock = {};
    var soldOut = {};
    var byOptions = (inv && inv.byOptions) || {};
    var qty = (inv && inv.qty) || {};
    Object.keys(byOptions).forEach(function (key) {
      var pair = splitKey(key);
      if (!pair) return;
      var id = String(byOptions[key]);
      var raw = qty[id];
      if (raw == null) raw = qty[Number(id)];
      var count = parseInt(raw, 10);
      if (isNaN(count)) return;
      if (count > 0) {
        if (!stock[pair.color]) stock[pair.color] = {};
        stock[pair.color][pair.size] = { q: count, id: id };
      } else {
        if (!soldOut[pair.color]) soldOut[pair.color] = [];
        soldOut[pair.color].push(pair.size);
      }
    });
    return { stock: stock, soldOut: soldOut };
  }

  function findColor(stock, color) {
    var want = norm(color);
    var names = Object.keys(stock || {});
    for (var i = 0; i < names.length; i++) {
      if (norm(names[i]) === want) return names[i];
    }
    return "";
  }

  function sizeQty(stock, color, size) {
    var found = findColor(stock, color);
    if (!found) return null;
    var sizes = stock[found] || {};
    var want = norm(size);
    var keys = Object.keys(sizes);
    for (var i = 0; i < keys.length; i++) {
      if (norm(keys[i]) === want) return { color: found, size: keys[i], cell: sizes[keys[i]] };
    }
    return null;
  }

  function familyOf(color) {
    var key = norm(color);
    if (FAMILIES[key]) return FAMILIES[key];
    var names = Object.keys(FAMILIES);
    for (var i = 0; i < names.length; i++) {
      if (key.indexOf(names[i]) !== -1) return FAMILIES[names[i]];
    }
    return [key];
  }

  function offersFor(inv, similar, color) {
    var parsed = stockFromInventory(inv || {});
    var sold = (parsed.soldOut[findColor(parsed.soldOut, color) || color] || []).slice();
    if (!color || !sold.length) return { color: color || "", rows: [] };
    var rows = sold.map(function (size) {
      var same = [];
      Object.keys(parsed.stock).forEach(function (name) {
        if (norm(name) === norm(color)) return;
        var hit = sizeQty(parsed.stock, name, size);
        if (hit) same.push({ color: hit.color, q: hit.cell.q, id: hit.cell.id });
      });
      same.sort(function (a, b) { return b.q - a.q; });
      var exact = [];
      var close = [];
      (similar || []).forEach(function (item) {
        var direct = sizeQty(item.stock || {}, color, size);
        if (direct && direct.cell.q > 0) {
          exact.push(card(item, direct, color));
          return;
        }
        var names = familyOf(color);
        for (var i = 0; i < names.length; i++) {
          if (norm(names[i]) === norm(color)) continue;
          var near = sizeQty(item.stock || {}, names[i], size);
          if (near && near.cell.q > 0) {
            close.push(card(item, near, color));
            break;
          }
        }
      });
      return {
        size: size,
        sameShirt: same.slice(0, 8),
        exact: exact.slice(0, 4),
        close: exact.length ? [] : close.slice(0, 4)
      };
    });
    return { color: color, rows: rows };
  }

  function pickCell(stock, color) {
    var found = findColor(stock, color);
    var sizes = found ? stock[found] : null;
    if (!sizes || !Object.keys(sizes).length) {
      var names = Object.keys(stock || {});
      if (!names.length) return null;
      found = names[0];
      sizes = stock[found] || {};
    }
    var keys = Object.keys(sizes);
    if (!keys.length) return null;
    var best = keys[0];
    keys.forEach(function (key) {
      if ((sizes[key].q || 0) > (sizes[best].q || 0)) best = key;
    });
    return { color: found, size: best, cell: sizes[best] };
  }

  function economyFor(similar, color, ownPrice) {
    var own = Number(ownPrice);
    if (!own) return [];
    return (similar || []).filter(function (item) {
      return item && item.price != null && Number(item.price) > 0 && Number(item.price) < own;
    }).sort(function (a, b) {
      return Number(a.price) - Number(b.price);
    }).map(function (item) {
      var hit = pickCell(item.stock || {}, color);
      if (!hit) return null;
      var made = card(item, hit, color);
      made.price = Number(item.price);
      return made;
    }).filter(Boolean);
  }

  function money(cents) {
    return "$" + (Number(cents) / 100).toFixed(2);
  }

  function swatchBackground(section, color) {
    if (!section || !section.querySelectorAll) return "";
    var nodes = section.querySelectorAll(".ezink-pdp-swatch");
    var want = norm(color);
    for (var i = 0; i < nodes.length; i++) {
      var name = nodes[i].getAttribute("data-color") || "";
      if (name !== color && norm(name) !== want) continue;
      var raw = nodes[i].getAttribute("style") || "";
      var match = raw.match(/background-image:\s*url\((['"]?)(.*?)\1\)/i);
      if (!match || !match[2]) return "";
      return "url('" + match[2].replace(/_80x(?=\.)/i, "_200x") + "')";
    }
    return "";
  }

  function imageFor(item, color) {
    var images = (item && item.images) || {};
    var names = Object.keys(images);
    var want = norm(color);
    for (var i = 0; i < names.length; i++) {
      if (norm(names[i]) === want && images[names[i]]) return images[names[i]];
    }
    return (item && item.image) || "";
  }

  function card(item, hit, requested) {
    var id = hit.cell.id;
    var href = "/products/" + item.handle + (id ? "?variant=" + encodeURIComponent(id) : "");
    return {
      title: item.title || item.handle,
      handle: item.handle,
      image: imageFor(item, hit.color),
      href: href,
      q: hit.cell.q,
      color: hit.color,
      size: hit.size,
      sameColor: norm(hit.color) === norm(requested)
    };
  }

  function selectedColor(section) {
    var sw = section.querySelector(".ezink-pdp-swatch.is-selected");
    if (sw && sw.getAttribute("data-color")) return sw.getAttribute("data-color");
    var sel = section.querySelector("[data-ezink-color-select]");
    if (sel && sel.value) return sel.value;
    return section.getAttribute("data-active-color") || "";
  }

  function readJson(id) {
    var node = document.getElementById(id);
    if (!node) return null;
    try { return JSON.parse(node.textContent || ""); } catch (err) { return null; }
  }

  function readJsonPrefix(prefix) {
    var node = document.querySelector('script[id^="' + prefix + '"]');
    if (!node) return null;
    try { return JSON.parse(node.textContent || ""); } catch (err) { return null; }
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function render(box, section, view, economy, similarCount) {
    var body = box.querySelector("[data-ezink-similar-body]");
    var economyBody = box.querySelector("[data-ezink-similar-economy]");
    if (!body || !economyBody) return;
    body.textContent = "";
    economyBody.textContent = "";
    var rows = (view && view.rows) || [];
    var cheaper = economy || [];
    if (!rows.length && !cheaper.length && !similarCount) {
      box.hidden = true;
      return;
    }
    if (cheaper.length) {
      economyBody.appendChild(cards(cheaper, true));
    } else {
      economyBody.appendChild(el("p", "ezink-similar__empty", "No lower-priced shirt of this kind."));
    }
    var soldTab = box.querySelector('[data-ezink-tab="soldout"]');
    if (soldTab) {
      soldTab.hidden = !rows.length;
      if (!rows.length && soldTab.classList.contains("is-selected")) showTab(box, "economy");
    }
    if (!rows.length) {
      body.appendChild(el("p", "ezink-similar__empty", "Every size of this color is in stock."));
    }
    rows.forEach(function (row) {
      var block = el("div", "ezink-similar__block");
      block.appendChild(el("h3", "ezink-similar__title", view.color + " " + sizeWords(row.size) + " is sold out."));
      if (row.sameShirt.length) {
        block.appendChild(el("p", "ezink-similar__label", "Same shirt, " + sizeWords(row.size) + " in stock"));
        var colors = el("div", "ezink-similar__colors");
        row.sameShirt.forEach(function (alt) {
          var btn = el("button", "ezink-similar__color");
          btn.type = "button";
          btn.setAttribute("data-ezink-similar-color", alt.color);
          btn.setAttribute("aria-label", alt.color + ", " + Number(alt.q).toLocaleString() + " in stock");
          var swatch = el("span", "ezink-similar__swatch");
          swatch.setAttribute("aria-hidden", "true");
          var bg = swatchBackground(section, alt.color);
          if (bg) swatch.style.backgroundImage = bg;
          btn.appendChild(swatch);
          btn.appendChild(el("span", "ezink-similar__color-name", alt.color));
          btn.appendChild(el("span", "ezink-similar__qty", Number(alt.q).toLocaleString() + " in stock"));
          colors.appendChild(btn);
        });
        block.appendChild(colors);
      }
      if (row.exact.length) {
        block.appendChild(el("p", "ezink-similar__label", "Similar shirts in " + view.color + " " + sizeWords(row.size)));
        block.appendChild(cards(row.exact));
      } else if (row.close.length) {
        block.appendChild(el("p", "ezink-similar__label", "No other shirt has " + view.color + " in " + sizeWords(row.size) + ". Closest in stock"));
        block.appendChild(cards(row.close));
      } else if (!row.sameShirt.length) {
        block.appendChild(el("p", "ezink-similar__label", "No substitute in this size right now."));
      }
      body.appendChild(block);
    });
    box.hidden = false;
    if (!box.getAttribute("data-ezink-similar-bound")) {
      box.setAttribute("data-ezink-similar-bound", "1");
      box.addEventListener("click", function (event) {
        var tab = event.target.closest("[data-ezink-tab]");
        if (tab && box.contains(tab)) {
          showTab(box, tab.getAttribute("data-ezink-tab"));
          return;
        }
        var btn = event.target.closest("[data-ezink-similar-color]");
        if (!btn) return;
        var color = btn.getAttribute("data-ezink-similar-color");
        var swatches = section.querySelectorAll(".ezink-pdp-swatch");
        for (var i = 0; i < swatches.length; i++) {
          if (swatches[i].getAttribute("data-color") === color) {
            swatches[i].click();
            return;
          }
        }
        var select = section.querySelector("[data-ezink-color-select]");
        if (select) {
          select.value = color;
          select.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
    }
  }

  function showTab(box, name) {
    var tabs = box.querySelectorAll("[data-ezink-tab]");
    var panels = box.querySelectorAll("[data-ezink-panel]");
    for (var i = 0; i < tabs.length; i++) {
      var on = tabs[i].getAttribute("data-ezink-tab") === name;
      tabs[i].classList.toggle("is-selected", on);
      tabs[i].setAttribute("aria-selected", on ? "true" : "false");
    }
    for (var j = 0; j < panels.length; j++) {
      panels[j].hidden = panels[j].getAttribute("data-ezink-panel") !== name;
    }
  }

  function cards(items, withPrice) {
    var wrap = el("div", "ezink-similar__cards");
    items.forEach(function (item) {
      var link = el("a", "ezink-similar__card");
      link.href = item.href;
      if (item.image) {
        var img = document.createElement("img");
        img.src = item.image;
        img.alt = "";
        link.appendChild(img);
      }
      var copy = el("span", "ezink-similar__copy");
      copy.appendChild(el("strong", null, item.title));
      var detail = item.color + " " + item.size;
      if (withPrice && item.price != null) detail += " · " + money(item.price);
      else detail += " · " + Number(item.q).toLocaleString() + " in stock";
      copy.appendChild(el("span", null, detail));
      link.appendChild(copy);
      wrap.appendChild(link);
    });
    return wrap;
  }

  return {
    splitKey: splitKey,
    stockFromInventory: stockFromInventory,
    offersFor: offersFor,
    economyFor: economyFor,
    selectedColor: selectedColor,
    readJson: readJson,
    readJsonPrefix: readJsonPrefix,
    render: render,
    sizeWords: sizeWords
  };
});
